/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { autobind } from "core-decorators";
import classnames from "classnames";
import ScrollAreaContainer from "containers/ScrollAreaContainer";
import keycode from "keycode";

export { default as Hero } from "./Hero";
export { default as Marker } from "./Marker";

export default class VerticalModalList extends PureComponent {
  static displayName = "VerticalModalList";

  static propTypes = {
    "aria-label": PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    footer: PropTypes.node,
    handleClose: PropTypes.func.isRequired,
    hero: PropTypes.node,
    ignoreNav: PropTypes.bool,
    needsModifiedScrollbars: PropTypes.bool,
    spaced: PropTypes.bool,
    style: PropTypes.object,
    userReportedStoryAbuse: PropTypes.func,
  };

  static defaultProps = {
    "aria-label": "",
    ignoreNav: false,
    needsModifiedScrollbars: false,
    role: "",
    spaced: false,
  };

  @autobind
  handleClose(event) {
    if (event.target === this.refs.mainContainer) {
      this.props.handleClose();
    }
  }

  render() {
    return (
      <div
        aria-label={this.props["aria-label"]}
        className={classnames("vertical-modal-list", this.props.className)}
        onClick={this.handleClose}
        onKeyUp={(event) => {
          switch (keycode(event).toLowerCase()) {
            case "enter":
            case "space":
              this.props.handleClose?.();
          }
        }}
        ref="mainContainer"
        role="dialog"
        style={this.props.style}
      >
        <div className="vertical-modal-list-container">
          <div
            className={classnames("vertical-modal-list-container-content", {
              "vertical-modal-list-container-content--ignore-nav":
                this.props.ignoreNav,
            })}
          >
            {this.props.hero}
            <ScrollAreaContainer
              className={classnames("vertical-modal-list__list", {
                "vertical-modal-list__list--spaced": this.props.spaced,
                "vertical-modal-list__list--native-scrolling":
                  !this.props.needsModifiedScrollbars,
              })}
              horizontal={false}
              smoothScrolling
            >
              {this.props.children}
            </ScrollAreaContainer>
            {this.props.footer}
          </div>
        </div>
      </div>
    );
  }
}
